






















import { Vue, Component, Prop } from 'vue-property-decorator';
import VueCanvasPoster from 'vue-canvas-poster';
import { Popup, Button } from 'vant';
import clounbtn from '../components/CloundbtnInfo.vue';
import QRCode from 'qrcode';
import { zIndex } from 'html2canvas/dist/types/css/property-descriptors/z-index';
Vue.use(Popup)
  .use(Button)
  .use(VueCanvasPoster);
@Component({
  components: {
    clounbtn,
    // FloatLikeBtn,
    // vueCanvasPoster,
  },
})
export default class Canvas extends Vue {
  @Prop({ default: true }) isshow!: boolean;
  @Prop() item: any;
  btnimg: any = require('../assets/canvas/cancavsbtn.png');
  option: any = {};
  showCanvas = false;
  src = '';
  painting = {};
  QR_CODE = '';

  toggle() {
    if (!this.src) {
      this.getPainting();
    }
    this.showCanvas = !this.showCanvas;
  }
  getPainting() {
    QRCode.toDataURL(
      'https://testdev.cqcb.com/2023h2/BYD0621/tovoteDetail?inway=' +
        this.item.inway +
        '&userId=' +
        this.item.userId,
      (err: any, url: string) => {
        if (err) {
          console.log('err occur:', err);
        } else {
          this.QR_CODE = url;
        }
      },
    );
    // QRCode.toDataURL(
    //   'https://activity.cqcb.com/shangyou_activity/2023h2/BYD0621/tovoteDetail?inway=' +
    //     this.item.inway +
    //     '&userId=' +
    //     this.item.userId,
    //   (err: any, url: string) => {
    //     if (err) {
    //       console.log('err occur:', err);
    //     } else {
    //       this.QR_CODE = url;
    //     }
    //   },
    // );
    // 开始绘制
    this.painting = {
      width: '1080px',
      height: '1920px',
      background: require('../assets/canvas/backimg.png'),
      views: [
        {
          type: 'image',
          id: 'backimg',
          url: require('../assets/canvas/content.png'),
          css: {
            top: '670px',
            left: '100px',
            width: '880px',
            height: '1200px',
            mode: 'scaleToFill',
          },
        },
        {
          type: 'image',
          id: 'headimg1',
          url: require('../assets/canvas/imgborder.png'),
          css: {
            top: '560px',
            left: '430px',
            width: '220px',
            height: '220px',
            mode: 'scaleToFill',
            borderRadius: '300px',
          },
        },
        {
          type: 'image',
          id: 'headimg',
          url: this.item.headimg,
          css: {
            top: '570px',
            left: '440px',
            width: '200px',
            height: '200px',
            mode: 'scaleToFill',
            borderRadius: '300px',
            opacity: 1,
          },
        },
        {
          type: 'text',
          id: 'name1',
          text: `${this.item.uname}`,
          css: {
            top: '830px',
            left: '240px',
            color: '#fff',
            fontSize: '40px',
            textAlign: 'center',
            width: '600px',
          },
        },
        {
          type: 'text',
          id: 'name2',
          text: `编号：${this.item.id}`,
          css: {
            top: '890px',
            left: '240px',
            color: '#DAE3FD',
            fontSize: '35px',
            textAlign: 'center',
            width: '600px',
          },
        },
        {
          type: 'text',
          id: 'name3',
          text: '我正在参加\n比亚迪达人共创大赛',
          css: {
            top: '1060px',
            left: '240px',
            color: '#fff',
            fontSize: '50px',
            lineHeight: '60px',
            textAlign: 'center',
            width: '600px',
          },
        },
        {
          type: 'text',
          id: 'name4',
          text: '快来为我助力吧！',
          css: {
            top: '1200px',
            left: '240px',
            color: '#DAE3FD',
            fontSize: '35px',
            textAlign: 'center',
            width: '600px',
          },
        },
        {
          type: 'image',
          url: require('../assets/canvas/qrborder.png'),
          css: {
            top: '1350px',
            left: '360px',
            color: '#000',
            width: '360px',
            height: '360px',
          },
        },
        {
          type: 'image',
          url: this.QR_CODE,
          css: {
            top: '1380px',
            left: '390px',
            color: '#000',
            width: '300px',
            height: '300px',
          },
        },
        {
          type: 'text',
          id: 'text1',
          text: '扫码助力',
          css: {
            bottom: '130px',
            left: '240px',
            color: '#DAE3FD',
            fontSize: '35px',
            textAlign: 'center',
            width: '600px',
          },
        },
      ],
    };
  }

  success(src: any) {
    // 设置img的src
    this.src = src;
  }
  fail(err: any) {
    console.log('fail', err);
  }
}
